import React from "react"
import PropTypes from "prop-types"
import { Navigate } from "react-router-dom"
import { usePortalTenant } from "context/PortalTenantContext"
import { ROUTES } from "constants/routes"
import Spinners from "components/Shared/Spinners"

const CustomLoginRouteGuard = ({ children }) => {
  const { loading, isCustomLoginActive } = usePortalTenant()

  if (loading) {
    return <Spinners />
  }

  if (isCustomLoginActive) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  return children
}

CustomLoginRouteGuard.propTypes = {
  children: PropTypes.node,
}

export default CustomLoginRouteGuard
